if (!customElements.get('arro-reasons')) {
  customElements.define('arro-reasons', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const { signal } = this.controller;
      this.querySelector('[data-as-variant]')?.addEventListener('change', (event) => {
        const option = event.target.selectedOptions[0];
        const button = this.querySelector('[data-as-submit]');
        const available = option.dataset.available === 'true';
        this.querySelectorAll('[data-as-price], [data-as-sticky-price]').forEach(node => { node.textContent = option.dataset.price; });
        const compare = this.querySelector('[data-as-compare]');
        if (compare) { compare.textContent = option.dataset.compare; compare.hidden = !option.dataset.compare; }
        button.disabled = !available;
        button.textContent = available ? button.dataset.availableLabel : button.dataset.soldOutLabel;
      }, { signal });
      const sticky = this.querySelector('[data-as-sticky]');
      const hero = this.querySelector('.as-hero');
      const offer = this.querySelector('.as-offer');
      if (sticky && hero && offer && 'IntersectionObserver' in window) {
        let pastHero = false;
        let nearOffer = false;
        const update = () => { sticky.hidden = !pastHero || nearOffer; };
        this.observer = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (entry.target === hero) pastHero = !entry.isIntersecting && entry.boundingClientRect.bottom < 0;
            if (entry.target === offer) nearOffer = entry.isIntersecting || entry.boundingClientRect.top < 0;
          });
          update();
        });
        this.observer.observe(hero);
        this.observer.observe(offer);
      }
    }
    disconnectedCallback() { this.controller?.abort(); this.observer?.disconnect(); }
  });
}
